const header = [
  { text: 'Application Id', value: 'application_id' },
  { text: 'Ref Campaign Id', value: 'ref_campaign_id' },
  { text: 'Name', value: 'name' },
  { text: 'Is Active', value: 'is_active' },
  { text: 'Action', value: 'actions', sortable: false }
]

export default header
